<template>
  <div v-if="userData.checkSms && isSend">
    <p class="step-sub-title">
      <b>{{ userData.cell }}</b> 번호로<br />
      인증 번호를 전송해 드렸습니다.
    </p>
    <div class="timer">남은 시간 {{ $helper.format_dp_time(startNumber) }}</div>
    <v-row class="row-code">
      <v-col cols="12">
        <v-text-field
          label="인증번호"
          ref="refCode"
          solo
          height="52"
          required
          type="number"
          v-model="reqData.inputCode"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <div class="link-group">
      <div>
        <v-label>인증번호를 못 받으셨나요?</v-label>
      </div>
      <div>
        <v-btn mini depressed rounded @click="reSend"> 재전송 </v-btn>
      </div>
    </div>
    <p class="mt-10">
      입력한 휴대 전화번호 재확인 또는 1577-4644 발신번호의 수신차단여부를
      확인해주세요.
    </p>
    <div class="bottom-btn">
      <v-btn
        color="primary"
        x-large
        depressed
        block
        rounded
        :disabled="userData.checkedSms"
        @click="$emit('completeCertify')"
        >인증완료</v-btn
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    userData: {
      type: Object,
    },
    reqData: {
      type: Object,
    },
  },
  data() {
    return {
      defaultTime: 4 * 60,
      startNumber: 0,
      isSend: false,
      timer: {
        sDate: null,
        eDate: null,
        tik: 0,
        pointer: null,
        isPlaying: false,
      },
    };
  },
  mounted() {
    // 개발시 사용
    // this.startTimer(true);
    this.userData.checkedSms = false;
    this._reSetTimer();
  },
  methods: {
    _reSetTimer() {
      this.timer.pointer = null;
      clearInterval(this.timer.pointer);
    },
    reSend() {
      this.startNumber = this.defaultTime;
      this.$emit("resend");
    },
    startTimer(isSend) {
      this.isSend = isSend;
      this.startNumber = this.defaultTime;
      this.timer.sDate = this.$moment();
      this.timer.isPlaying = true;
      this.timer.pointer = setInterval(() => {
        const currentTime = this.$moment();
        this.timer.tik = Math.floor(
          this.$moment.duration(currentTime.diff(this.timer.sDate)).asSeconds()
        );
        this.timer.eDate = this.$moment();
        this.startNumber--;
        if (this.startNumber === 0) {
          this.$emit("gotoSmsInput");
        }
        console.log("", this.$helper.format_dp_time(this.startNumber));
      }, 1000);
    },
  },
};
</script>
<style lang="">
</style>